import { paths, PlatformLocalUser } from 'shared/base';

export function getConditionalRoutes(user: PlatformLocalUser | undefined) {
  return [
    {
      isAllowed: user?.roles?.some((role) => role.includes('admin')),
      path: paths.platform.admin.settings.index,
    },
    {
      isAllowed: user?.roles?.some((role) => role.includes('admin')),
      path: paths.platform.admin.users.index,
    },
  ];
}
